import SchoolIcon from '@mui/icons-material/School'

export const routeFrontOfficeSchoolFormathequeCommonUser = [
  {
    route: 'TrainingLibrary',
    text: 'Formathèque',
    mobileText: 'Formations',
    t: 'routes.frontoffice.school.training',
    href: '/frontoffice/school/training/trainings-library',
    menuHeader: true,
    icon: SchoolIcon,
    position: 400,
    positionMobile: 200,
  },
]
